(function($) {
  const sliderImages = "slider-custom__images";
  const sliderImagesContainer = `${sliderImages}-container`;
  let currentIndex = 0;
  let currentSlideIndex = currentIndex + 2;
  let isAnimating = false;
  const images = "";

  const riviste = $(".slider-custom-v1").data("content");

  const init = $(".slider-custom__images-container").html();

  arrowBackward();
  arrowForward();

  function canGoBack() {
    return currentIndex < riviste.length - 1;
  }

  function canGoForward() {
    return riviste.length > 0 && currentIndex > 0;
  }

  function arrowForward() {
    if (!canGoForward()) {
      $(`.${sliderImages}-btn .forward`).addClass("inactive");
    } else {
      $(`.${sliderImages}-btn .forward`).removeClass("inactive");
    }
  }

  function arrowBackward() {
    if (!canGoBack()) {
      $(`.${sliderImages}-btn .backward`).addClass("inactive");
    } else {
      $(`.${sliderImages}-btn .backward`).removeClass("inactive");
    }
  }

  function hasOtherRiviste() {
    return currentSlideIndex < riviste.length - 1;
  }

  function changeContent(rivista) {
    const contentContainer = $(".slider-custom__content");

    contentContainer.animate(
      {
        opacity: 0,
      },
      400,
      null,
      () => {
        contentContainer
          .html(
            `
            <div class="p-md max-w-4xl lg:max-w-2xl">
            <h2>In questo numero</h2>
              <h3>${rivista["post_title"]}</h3>
              <div class="mt-md"></div>
              <hr class="text-black opacity-25"/>
  
              ${rivista["post_content"]}
          </div>
      `
          )
          .animate({ opacity: 1 }, 100);
      }
    );

    // contentContainer.find("h2").text(rivista["title"]);
    // contentContainer.find("h3").text(rivista["subtitle"]);
    // contentContainer.find("p").text(rivista["text"]);
  }

  function handleBack() {
    if (!canGoBack() || isAnimating) {
      return;
    }

    isAnimating = true;

    // remove child-1 from the dom
    $(`.${sliderImages} .child-1`)
      .removeClass("child-1")
      .addClass("exiting");

    setTimeout(() => {
      $(`.${sliderImages} .exiting`).remove();
    }, 500);

    // child-2 now become the active one
    $(`.${sliderImages} .child-2`)
      .addClass("child-1")
      .removeClass("child-2");

    // Duplicate last child
    const newChild3 = $(`.${sliderImages} .child-3`)
      .clone(true)
      .removeClass("entering")
      .removeClass("exiting")
      .removeClass("child")
      .removeClass("child-3");

    // child-3 now become the child 2
    $(`.${sliderImages} .child-3`)
      .addClass("child-2")
      .removeClass("child-3");

    if (hasOtherRiviste()) {
      currentSlideIndex += 1;
      // Get next rivista from riviste array
      const rivista = riviste[currentSlideIndex];

      $(newChild3)
        .find("img")
        .attr("src", rivista.img);

      // Append the new child
      newChild3.addClass("entering").appendTo(`.${sliderImagesContainer}`);

      setTimeout(() => {
        newChild3
          .removeClass("entering")
          .addClass("child")
          .addClass("child-3");
      }, 200);
    }

    setTimeout(() => {
      isAnimating = false;
    }, 500);

    currentIndex += 1;

    changeContent(riviste[currentIndex]);

    arrowBackward();
    arrowForward();
  }

  function handleForward() {
    if (isAnimating || !canGoForward()) return;

    isAnimating = true;
    currentIndex = 0;
    currentSlideIndex = currentIndex + 2;

    arrowBackward();
    arrowForward();

    changeContent(riviste[0]);

    $(`.${sliderImagesContainer}`).animate(
      {
        opacity: 0,
      },
      400,
      null,
      () => {
        $(`.${sliderImagesContainer}`)
          .html(init)
          .animate({ opacity: 1 }, 100);
      }
    );

    setTimeout(() => {
      isAnimating = false;
    }, 200);
  }

  $(".slider-custom__images-btn .backward").on("click", handleBack);
  $(".slider-custom__images-btn .forward").on("click", handleForward);
})(jQuery);
